var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMessengerBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H32C40.8366 0 48 7.16344 48 16V32C48 40.8366 40.8366 48 32 48H16C7.16344 48 0 40.8366 0 32V16Z",
    fill: "#304FFD",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.375C30.5625 12.375 35.625 17.2031 35.625 23.6719C35.625 31.875 27.7969 36.4688 20.625 34.5C20.2031 34.4062 20.1562 34.5 17.7188 35.5781C17.1094 35.8125 16.4062 35.3906 16.4062 34.7344C16.3125 32.5781 16.4062 32.3906 16.0312 32.0156C13.7344 30 12.375 27.0469 12.375 23.6719C12.375 17.2031 17.4375 12.375 24 12.375ZM30.9844 21.0938C31.3125 20.5781 30.7031 19.9688 30.1875 20.3438L26.5312 23.1094C26.25 23.2969 25.9219 23.2969 25.6875 23.1094L22.9688 21.0938C22.125 20.4844 20.9531 20.6719 20.4375 21.5625L17.0156 26.9531C16.6875 27.4688 17.2969 28.0781 17.8125 27.7031L21.4688 24.9375C21.75 24.75 22.0781 24.75 22.3125 24.9375L25.0312 26.9531C25.875 27.5625 27.0469 27.375 27.5625 26.4844L30.9844 21.0938Z",
    fill: "#0071CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessengerBg);
export default __webpack_public_path__ + "static/media/icMessengerBg.25673a40270d60e0a3c3188a7de4bbf6.svg";
export { ForwardRef as ReactComponent };